import React from 'react';
import '../../pages/pages.css';
import homeImg from './home.PNG';

function Home() {
  return (
    <div className="page-container">
      <div className="page-image">
        <img src={homeImg} />
      </div>
      <div className="page-text">
        <h1>COLLABTECHNIQS CONSULTING PRIVATE LIMITED</h1>
        <p>
          is a women-owned and operated startup dedicated to revolutionizing the audio-visual (AV) and collaboration landscape. 
        </p>
        <p>
          Founded in 2025 by two seasoned professionals with rich individual experience in the unified collaboration and AV industry. 
        </p>
        <p>
          Our company aims to bridge the gap in the AV & IT industry by 
          providing innovative, robust, and simplified collaboration solutions.
        </p>
      </div>
    </div>
  );
}

export default Home;